import React from 'react';

import './projhist.css';

import ProjectHistoryEntry from './ProjectHistoryEntry';

import ProjectHistoryData from './ProjectHistoryData';

import ProjectHistoryList from './ProjectHistoryList';

import PdfLogo from '../assets/Adobe_PDF_file_icon_32x32.png';
import ProjectHistoryPdf from '../assets/Roy_Watson--Project_History.pdf'


class ProjectHistory extends React.Component {

    constructor(props) {
        super();

        this.data = new ProjectHistoryData();
//        this.projhist = this.data.getFilteredData([],[],[]);

        this.state = {
            filters: {
                industries: [],
                andTechs: false,
                techs: [],
                andSearch: false,
                search: [],
            }
        };

        this.industryList = this.data.getIndustriesList();
        this.technologiesList = this.data.getTechnologiesList();

        this.onIndustryCheckboxChanged = this.onIndustryCheckboxChanged.bind(this);
        this.onTechsCheckboxChanged = this.onTechsCheckboxChanged.bind(this);
        this.onCheckboxChanged = this.onCheckboxChanged.bind(this);
        this.onTechRadiobuttonClicked = this.onTechRadiobuttonClicked.bind(this);
        this.onSearchRadiobuttonClicked = this.onSearchRadiobuttonClicked.bind(this);
        this.setAllIndustriesCheckboxes = this.setAllIndustriesCheckboxes.bind(this);
        this.onAllIndustriesCheckboxChanged = this.onAllIndustriesCheckboxChanged.bind(this);
        this.setAllTechnologiesCheckboxes = this.setAllTechnologiesCheckboxes.bind(this);
        this.onAllTechnologiesCheckboxChanged = this.onAllTechnologiesCheckboxChanged.bind(this);
    }

    componentDidMount() {
        console.log("componentDidMount()");
        var allindustry = document.getElementById("allindustry");
        allindustry.checked = true;
        this.setAllIndustriesCheckboxes(true);
        var alltechs = document.getElementById("alltechs");
        alltechs.checked = true;
        this.setAllTechnologiesCheckboxes(true);
    }

    toggleSelectorsPanel() {
        console.log("toggleSelectorsPanel()");
        var button = document.getElementById("selectors-button");
        button.classList.toggle("active");
        var panel = document.getElementById("selectors-panel");
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    }

    toggleIndustriesPanel() {
        console.log("toggleIndustriesPanel()");
        var button = document.getElementById("industries-button");
        button.classList.toggle("active");
        var panel = document.getElementById("industries-panel");
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";

            var containerPanel = document.getElementById("selectors-panel");
            containerPanel.style.maxHeight = "1000000px";
        }
    }

    toggleTechnologiesPanel() {
        console.log("toggleTechnologiesPanel()");
        var button = document.getElementById("technologies-button");
        button.classList.toggle("active");
        var panel = document.getElementById("technologies-panel");
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";

            var containerPanel = document.getElementById("selectors-panel");
            containerPanel.style.maxHeight = "1000000px";
        }
    }

    toggleSearchPanel() {
        console.log("toggleSearchPanel()");
        var button = document.getElementById("search-button");
        button.classList.toggle("active");
        var panel = document.getElementById("search-panel");
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";

            var containerPanel = document.getElementById("selectors-panel");
            containerPanel.style.maxHeight = "1000000px";
        }
    }

    onIndustryCheckboxChanged() {
        var allindustry = document.getElementById("allindustry");
        allindustry.indeterminate = true;
        this.onCheckboxChanged();
    }

    onTechsCheckboxChanged() {
        var alltechs = document.getElementById("alltechs");
        alltechs.indeterminate = true;
        this.onCheckboxChanged();
    }

    onCheckboxChanged() {
        console.log("onCheckboxChanged()");
        var iboxes = document.getElementsByName("industrybox");
        var industries = [];
        for (var i = 0; i < iboxes.length; i++) {
            if (iboxes[i].type == "checkbox" && iboxes[i].checked == true) {
//                x[i].checked = true;
                industries.push(iboxes[i].value);
            }
        }

        var tboxes = document.getElementsByName("techbox");
        var techs = [];
        for (var i = 0; i < tboxes.length; i++) {
            if (tboxes[i].type == "checkbox" && tboxes[i].checked == true) {
//                x[i].checked = true;
                techs.push(tboxes[i].value);
            }
        }

        if (this) {
            this.setState(prevState => (
                {
                    filters: {
                        industries: industries,
                        andTechs: this.state.filters.andTechs,
                        techs: techs,
                        andSearch: this.state.filters.andSearch,
                        search: [],
                    }
                }
            ));
            console.log(industries);
        }
    }

    onTechRadiobuttonClicked() {
        console.log("onRadiobuttonClicked()");
        var tech_and = document.querySelector('input[name="combine-tech"]:checked').value;
        console.log("tech_and = ", tech_and);
        this.setState({
            filters: {
                industries: this.state.filters.industries,
                andTechs: tech_and,
                techs: this.state.filters.techs,
                andSearch: this.state.filters.andSearch,
                search: this.state.filters.search,
            }
        });
    }

    onSearchRadiobuttonClicked() {
        console.log("onRadiobuttonClicked()");
        var search_and = document.querySelector('input[name="combine-search"]:checked').value;
        console.log("search_and = ", search_and);
        this.setState({
            filters: {
                industries: this.state.filters.industries,
                andTechs: this.state.filters.andTechs,
                techs: this.state.filters.techs,
                andSearch: search_and,
                search: this.state.filters.search,
            }
        });
    }

    setAllIndustriesCheckboxes(checked) {
        var iboxes = document.getElementsByName("industrybox");
        for (var i = 0; i < iboxes.length; i++) {
            if (iboxes[i].type == "checkbox") {
                iboxes[i].checked = checked;
            }
        }
        this.onCheckboxChanged();
    }

    onAllIndustriesCheckboxChanged() {
        console.log("onAllIndustriesCheckboxChanged()");
        var tech_all = document.getElementById("allindustry").checked;
        console.log(tech_all);

        this.setAllIndustriesCheckboxes(tech_all);
    }

    setAllTechnologiesCheckboxes(checked) {
        var tboxes = document.getElementsByName("techbox");
        for (var i = 0; i < tboxes.length; i++) {
            if (tboxes[i].type == "checkbox") {
                tboxes[i].checked = checked;
            }
        }
        this.onCheckboxChanged();
    }

    onAllTechnologiesCheckboxChanged() {
        console.log("onAllTechnologiesCheckboxChanged()");
        var tech_all = document.getElementById("alltechs").checked;
        console.log(tech_all);

        this.setAllTechnologiesCheckboxes(tech_all);
    }

    render() {

        var resumeContainerStyle = {
            width: "100%",
            textAlign: "center",
            alignContent: "center",
            marginTop: 0,
            fontFamily: "'Libre Franklin'",
            color: "#e0e0e0"
        }

        var resumeHeaderSectionStyle = {
            width: "100%",
            textAlign: "center",
            alignContent: "center",
        }

        var resumeHeaderNameStyle = {
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: 24,
            width: "100%",
            textAlign: "center",
            alignContent: "center",
            padding: 0,
            margin: 0,
            marginBottom: 5,
        }

        var resumeHeaderAddressStyle = {
            width: "100%",
            textAlign: "center",
            alignContent: "center",
            padding: 0,
            margin: 0,
            color: "#c0c0c0"
        }

        var resumeHeaderEmailStyle = {
            width: "100%",
            textAlign: "center",
            alignContent: "center",
            padding: 0,
            margin: 0,
            color: "#c0c0c0"
        }

        var resumeHeaderPhoneStyle = {
            width: "100%",
            textAlign: "center",
            alignContent: "center",
            padding: 0,
            margin: 0,
            color: "#c0c0c0"
        }

        var projhistDownloadContentStyle = {
            width: "100%",
            alignContent: "center",
            margin: 0,
            marginBottom: 0,
            padding: 0,
        }

        var projhistDownloadSectionStyle = {
            marginTop: 25,
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: 0,
            textAlign: "left",
            padding: 0,
            width: "80%",
        }

        var projhistDownloadTextStyle = {
            color: "#c0c0c0",
            marginBottom: 0,
        }

        var projhistBodySectionStyle = {
            width: "85%",
            textAlign: "left",
            marginLeft: "auto",
            marginRight: "auto",
        }

        var projhistGeneralSectionTitleStyle = {
            textTransform: "uppercase",
            fontWeight: 700,
            width: "100%",
            textAlign: "left",
            marginBottom: 5,
        }

        var projhistGeneralSectionTextStyle = {}

        var itemListNoteStyle = {
            color: "#ff9d00",
            textAlign: "left",
            padding: 0,
        }

        var selectorSectionStyle = {
            marginLeft: 20,
        }

        var itemListStyle = {
            textAlign: "left",
            padding: 0,
            marginTop: 15,
        }

        var accordionButtonStyle = {
            backgroundColor: "#eee",
            color: "#444",
            cursor: "pointer",
            padding: 18,
            width: "100%",
            textAlign: "left",
            border: "none",
            outline: "none",
            transition: 1.0,
            ":hover": {
                color: "#000",
            }
        }

        var accordionPanelStyle = {
            padding: "0 18px",
            backgroundColor: "white",
            display: "none",
            overflow: "hidden",
        }

        var selectorGrid = {
            marginTop: 20,
            display: "flex",
            justifyContent: "left",
            flexWrap: "wrap"
        }

        var selectorGridItem = {
            margin: 10,
            border: "none",
        }

        return (
            <div>
                <div style={projhistDownloadContentStyle}>
                    <section style={projhistDownloadSectionStyle}>
                        <p style={projhistDownloadTextStyle}>
                            <img alt="pdf" src={PdfLogo}/>
                            <a style={projhistDownloadTextStyle}
                               href={ProjectHistoryPdf} download> Download pdf version
                            </a>
                        </p>
                    </section>
                </div>
                <div style={resumeContainerStyle}>
                    <section style={resumeHeaderSectionStyle}>
                        <p style={resumeHeaderNameStyle}>Roy Watson</p>
                        <p style={resumeHeaderAddressStyle}>P.O. Box 3298</p>
                        <p style={resumeHeaderAddressStyle}>Burlington, VT 05408</p>
                        <p style={resumeHeaderEmailStyle}>rwatson@roywatson.com</p>
                        <p style={resumeHeaderPhoneStyle}>+1 802.735.1500</p>
                    </section>
                    <section style={projhistBodySectionStyle}>

                        <section style={itemListNoteStyle}>
                            <p style={projhistGeneralSectionTitleStyle}>Note:</p>
                            <p style={projhistGeneralSectionTextStyle}>I have performed contract software development
                                professionally for many years. This is a list of some of the projects I have worked on
                                since 2000. There were other projects for a few clients (both legacy and new clients)
                                interspersed among the below projects.</p>
                        </section>


                        <button id="selectors-button" className="accordion outer"
                                onClick={this.toggleSelectorsPanel}>Customize the project history list ...
                        </button>
                        <div id="selectors-panel" className="outer-panel">
                            <div className="panelContent">

                                <section style={selectorSectionStyle}>
                                    <section style={itemListNoteStyle}>
                                        <p style={projhistGeneralSectionTextStyle}>Use the selectors below to filter my
                                            project history to your needs and interests:</p>
                                    </section>
                                    <button id="industries-button" className="accordion"
                                            onClick={this.toggleIndustriesPanel}>Industry Selectors ...
                                    </button>
                                    <div id="industries-panel" className="panel">
                                        <div className="panelContent">
                                            <div style={selectorGridItem}><input type="checkbox" id="allindustry"
                                                                                 value="all"
                                                                                 onChange={this.onAllIndustriesCheckboxChanged}/><label>Include
                                                All</label></div>
                                            <div style={selectorGrid}>
                                                {this.industryList.map((industry) =>
                                                    <div style={selectorGridItem}><input type="checkbox"
                                                                                         name="industrybox"
                                                                                         value={industry}
                                                                                         onChange={this.onIndustryCheckboxChanged}/><label>{industry}</label>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="logic-container">
                                        <input type="radio" name="combine-tech" value={true}
                                               onChange={this.onTechRadiobuttonClicked}/><label>and ;</label><input
                                        type="radio" name="combine-tech" value={false}
                                        onChange={this.onTechRadiobuttonClicked} defaultChecked={true}/><label>or
                                        ;</label>
                                    </div>
                                    <button id="technologies-button" className="accordion"
                                            onClick={this.toggleTechnologiesPanel}>Technologies Used Selectors ...
                                    </button>
                                    <div id="technologies-panel" className="panel">
                                        <div className="panelContent">
                                            <div style={selectorGridItem}><input type="checkbox" id="alltechs"
                                                                                 value="all"
                                                                                 onChange={this.onAllTechnologiesCheckboxChanged}/><label>Include
                                                All</label></div>
                                            <div style={selectorGrid}>
                                                {this.technologiesList.map((tech) =>
                                                    <div style={selectorGridItem}><input type="checkbox" name="techbox"
                                                                                         value={tech}
                                                                                         onChange={this.onTechsCheckboxChanged}/><label>{tech}</label>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="logic-container">
                                        <input type="radio" name="combine-search" value={true}
                                               onClick={this.onSearchRadiobuttonClicked}/><label>and ;</label><input
                                        type="radio" name="combine-search" value={false}
                                        onChange={this.onSearchRadiobuttonClicked} defaultChecked={true}/><label>or
                                        ;</label>
                                    </div>
                                    <button id="search-button" className="accordion"
                                            onClick={this.toggleSearchPanel}>Keyword Search ...
                                    </button>
                                    <div id="search-panel" className="panel">
                                        <div className="panelContent">
                                            <p>Lorem ipsum...</p>
                                        </div>
                                    </div>
                                </section>

                            </div>

                        </div>

                        <ProjectHistoryList filters={this.state.filters} displaycount/>

                    </section>
                </div>
            </div>
        );
    }
}

export default ProjectHistory


// WEBPACK FOOTER //
// src/ProjectHistory/ProjectHistory.js